import { NgModule } from "@angular/core";
import { ViewPreferenceComponent } from "./component/view-preference.component";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { FuseSharedModule } from "@fuse/shared.module";
import { MatIconModule } from "@angular/material/icon";

@NgModule({
  declarations: [ViewPreferenceComponent],
  imports: [
    //shared
    FuseSharedModule,

    //material
    MatButtonToggleModule,
    MatIconModule
  ],
  exports: [ViewPreferenceComponent]
})
export class ViewPreferenceModule {}
